import React from "react";

import { HUBO_ICON_URL } from "../../storeSearchInput.config";
import { SearchItem, SearchItemType } from "../../storeSearchInput.types";
import "./searchItem.scss";

type SearchItemProps = SearchItem;

const SearchItemComponent = ({ label, type, value }: SearchItemProps) => {
    if (!label) {
        return null;
    }
    return (
        <div key={value} className={"search-item"}>
            {type === SearchItemType.Locality && (
                <i className="las la-map-marker mr-1"></i>
            )}
            {type === SearchItemType.Store && (
                <img
                    src={HUBO_ICON_URL}
                    width="16"
                    height="18"
                    className="mr-1"
                />
            )}
            <span
                className={"search-item__label"}
                dangerouslySetInnerHTML={{ __html: label }}
            />
        </div>
    );
};

export { SearchItemComponent };
